import React from "react";

// --- SVG Icon Components (replaces react-icons to fix build error) ---
const ScheduleIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
    <line x1="16" y1="2" x2="16" y2="6"></line>
    <line x1="8" y1="2" x2="8" y2="6"></line>
    <line x1="3" y1="10" x2="21" y2="10"></line>
  </svg>
);

const DownloadIcon = ({ size = 14 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
    <polyline points="7 10 12 15 17 10"></polyline>
    <line x1="12" y1="15" x2="12" y2="3"></line>
  </svg>
);

const TrendIcon = ({ size = 14, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
    <polyline points="17 6 23 6 23 12"></polyline>
  </svg>
);

const LocationIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#3B82F6"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
    <circle cx="12" cy="10" r="3"></circle>
  </svg>
);

const UsersIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
    <circle cx="9" cy="7" r="4"></circle>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
  </svg>
);

const ActivityIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
  </svg>
);

const MessageSquareIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
  </svg>
);

const EyeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
    <circle cx="12" cy="12" r="3"></circle>
  </svg>
);

const PdfIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="#DB2777">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zM9.5 18H8v-5h1.5a1.5 1.5 0 0 1 0 3H9v2zm3-4.5a1.5 1.5 0 0 1 1.5-1.5h1a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-1A1.5 1.5 0 0 1 12.5 18v-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1.5h-2v-1zM18 17h-1.5v-5H18v5zM13 9V3.5L18.5 9H13z" />
  </svg>
);
const ExcelIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="#059669">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zM9.6 18H8l-1.6-2.4L4.8 18H3.2l2.4-3.6L3.2 10.8h1.6l1.6 2.4 1.6-2.4h1.6L7.2 14.4 9.6 18zm4.4-1.2h-3v-1.6h3v1.6zm0-3.2h-3v-1.6h3v1.6zm0-3.2h-3V8.8h3v1.6zM13 9V3.5L18.5 9H13z" />
  </svg>
);
const CsvIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="#6366F1">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zM8.5 18a1.5 1.5 0 0 1-1.5 1.5h-2a1.5 1.5 0 0 1 0-3H7a1.5 1.5 0 0 1 1.5 1.5zM12 19.5a1.5 1.5 0 0 1-3 0v-5a1.5 1.5 0 0 1 3 0v5zM18.5 15a1.5 1.5 0 0 1-1.5 1.5h-2a1.5 1.5 0 0 1 0-3h2a1.5 1.5 0 0 1 1.5 1.5zM13 9V3.5L18.5 9H13z" />
  </svg>
);

const FullReportAccess = () => {
  const reports = [
    {
      title: "Member Analytics Report",
      desc: "Comprehensive member growth and engagement metrics",
      generated: "1/15/2025",
    },
    {
      title: "State Performance Report",
      desc: "Performance metrics across all states and regions",
      generated: "1/20/2025",
    },
    {
      title: "Admin Summary Report",
      desc: "Revenue, costs, and financial KPIs overview",
      generated: "1/10/2025",
    },
    {
      title: "Admin Activity Report",
      desc: "Administrator actions and system usage statistics",
      generated: "1/21/2025",
    },
    {
      title: "Communication Report",
      desc: "Broadcast messages and engagement analytics",
      generated: "1/18/2025",
    },
  ];

  const trends = [
    {
      name: "Member Growth",
      change: "+18.2%",
      color: "#10B981",
      icon: <UsersIcon />,
    },
    {
      name: "Admin Activity",
      change: "+24.1%",
      color: "#10B981",
      icon: <ActivityIcon />,
    },
    {
      name: "Message Engagement",
      change: "+31.5%",
      color: "#10B981",
      icon: <MessageSquareIcon />,
    },
    {
      name: "Report Downloads",
      change: "+15.3%",
      color: "#10B981",
      icon: <DownloadIcon size={20} />,
    },
  ];

  const regions = [
    { name: "West Coast", members: "89,432 members", performance: 95 },
    { name: "Southwest", members: "76,194 members", performance: 88 },
    { name: "Northeast", members: "67,847 members", performance: 92 },
    { name: "Southeast", members: "54,639 members", performance: 85 },
  ];

  const exportOptions = [
    {
      format: "PDF Report",
      description: "Formatted for printing",
      icon: <PdfIcon />,
    },
    {
      format: "Excel Report",
      description: "Data Analysis is Ready",
      icon: <ExcelIcon />,
    },
    {
      format: "CSV Data",
      description: "Raw data for analysis",
      icon: <CsvIcon />,
    },
    {
      format: "PDF Summary",
      description: "Executive summary",
      icon: <PdfIcon />,
    },
  ];

  return (
    <>
      <style>{`
                .reports-grid {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    gap: 24px;
                }
                .performance-grid {
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    gap: 32px;
                    margin-top: 48px;
                }
                .export-grid {
                    display: grid;
                    grid-template-columns: repeat(4, 1fr);
                    gap: 24px;
                }
                @media (max-width: 1024px) {
                    .reports-grid { grid-template-columns: 1fr; }
                    .performance-grid { grid-template-columns: 1fr; }
                    .export-grid { grid-template-columns: repeat(2, 1fr); }
                }
                 @media (max-width: 640px) {
                    .header { flex-direction: column; align-items: flex-start; gap: 1rem; }
                    .stats-container { flex-direction: column; align-items: stretch; }
                    .export-grid { grid-template-columns: 1fr; }
                }
            `}</style>
      <div style={styles.page}>
        <div style={styles.container}>
          {/* Header */}
          <header style={styles.header} className="header">
            <div>
              <h1 style={styles.h1}>Full Reporting Access</h1>
              <p style={styles.subtitle}>
                Generate, view, and export comprehensive analytics reports
              </p>
            </div>
            <button style={styles.scheduleButton}>
              <ScheduleIcon />
              Schedule Report
            </button>
          </header>

          {/* Stats */}
          <div style={styles.statsContainer} className="stats-container">
            <div style={styles.statCard}>
              <p style={styles.statValue}>1,247</p>
              <p style={styles.statLabel}>Reports Generated</p>
              <p style={styles.statChange}>
                <TrendIcon size={14} style={{ marginRight: "4px" }} />
                +12.5% <span style={{ color: "#6B7280" }}>from last month</span>
              </p>
            </div>
            <div style={styles.statCard}>
              <p style={styles.statValue}>856</p>
              <p style={styles.statLabel}>Export Downloads</p>
              <p style={styles.statChange}>
                <TrendIcon size={14} style={{ marginRight: "4px" }} />
                +12.5% <span style={{ color: "#6B7280" }}>from last month</span>
              </p>
            </div>
            <div style={styles.statCard}>
              <p style={styles.statValue}>24</p>
              <p style={styles.statLabel}>Automated Reports</p>
              <p style={styles.statChange}>
                <TrendIcon size={14} style={{ marginRight: "4px" }} />
                +12.5% <span style={{ color: "#6B7280" }}>from last month</span>
              </p>
            </div>
          </div>

          {/* Available Reports */}
          <section style={{ marginTop: "48px" }}>
            <h2 style={styles.h2}>Available Reports</h2>
            <div className="reports-grid">
              {reports.map((report, index) => (
                <div key={index} style={styles.reportCard}>
                  <div style={styles.reportCardHeader}>
                    <div>
                      <h3 style={styles.reportTitle}>{report.title}</h3>
                      <p style={styles.reportDesc}>{report.desc}</p>
                    </div>
                    <span style={styles.monthlyBadge}>Monthly</span>
                  </div>
                  <p style={styles.reportGenerated}>
                    Last generated: {report.generated}
                  </p>
                  <div style={styles.reportCardFooter}>
                    <button style={styles.viewReportButton}>
                      <EyeIcon />
                      View Report
                    </button>
                    <button style={styles.downloadButton}>
                      <DownloadIcon />
                      Download
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* Performance Section */}
          <div className="performance-grid">
            {/* Trends */}
            <section>
              <div style={styles.sectionHeader}>
                <TrendIcon size={20} stroke="#3B82F6" />
                <h2 style={styles.h2}>Performance Trends</h2>
              </div>
              <div style={styles.trendsContainer}>
                {trends.map((trend, index) => (
                  <div key={index} style={styles.trendItem}>
                    <div style={styles.trendInfo}>
                      <div style={styles.trendIcon}>{trend.icon}</div>
                      <div>
                        <p style={styles.trendName}>{trend.name}</p>
                        <span style={styles.trendSubtitle}>vs last month</span>
                      </div>
                    </div>
                    <p style={{ ...styles.trendChange, color: trend.color }}>
                      {trend.change}
                    </p>
                  </div>
                ))}
              </div>
            </section>

            {/* Regional */}
            <section>
              <div style={styles.sectionHeader}>
                <LocationIcon />
                <h2 style={styles.h2}>Regional Performance</h2>
              </div>
              <div style={styles.regionsContainer}>
                {regions.map((region, index) => (
                  <div key={index} style={styles.regionItem}>
                    <div style={styles.regionHeader}>
                      <div>
                        <p style={styles.regionName}>{region.name}</p>
                        <p style={styles.regionMembers}>{region.members}</p>
                      </div>
                      <p style={styles.performanceValue}>
                        {region.performance}%
                      </p>
                    </div>
                    <div style={styles.progressBarBg}>
                      <div
                        style={{
                          ...styles.progressBarFg,
                          width: `${region.performance}%`,
                          backgroundColor:
                            region.performance >= 90
                              ? "#10B981"
                              : region.performance >= 80
                              ? "#3B82F6"
                              : "#F59E0B",
                        }}
                      ></div>
                    </div>
                  </div>
                ))}
              </div>
            </section>
          </div>

          {/* Export Options */}
          <section style={{ marginTop: "48px" }}>
            <h2 style={styles.h2}>Export & Download Options</h2>
            <div className="export-grid">
              {exportOptions.map((option, index) => (
                <div key={index} style={styles.exportCard}>
                  <div style={styles.exportIcon}>{option.icon}</div>
                  <p style={styles.exportTitle}>{option.format}</p>
                  <p style={styles.exportDesc}>{option.description}</p>
                </div>
              ))}
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

const styles = {
  page: {
    background: "linear-gradient(to bottom, #F0F9FF, #FFFFFF)",
    padding: "2rem",
    fontFamily:
      "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif",
    minHeight: "100vh",
  },
  container: {
    maxWidth: "1280px",
    margin: "0 auto",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: "2rem",
  },
  h1: {
    fontSize: "28px",
    fontWeight: "bold",
    color: "#2563EB",
    margin: 0,
    marginRight: "12rem", // Even more to the left
  },
  subtitle: {
    color: "grey",
    fontSize: "16px",
    margin: "7px 0 0 0",
  },
  scheduleButton: {
    backgroundColor: "#2563EB",
    color: "white",
    border: "none",
    borderRadius: "6px",
    padding: "10px 16px",
    fontWeight: "500",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "14px",
    width: "fit-content",
  },
  statsContainer: {
    display: "flex",
    gap: "24px",
    marginBottom: "2rem",
  },
  statCard: {
    backgroundColor: "white",
    padding: "24px",
    borderRadius: "8px",
    border: "1px solid #E5E7EB",
    flex: 1,
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
  },
  statValue: {
    fontSize: "36px",
    fontWeight: "bold",
    color: "#1F2937",
    margin: 0,
  },
  statLabel: {
    fontSize: "14px",
    color: "#6B7280",
    margin: "4px 0 8px 0",
  },
  statChange: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#10B981",
    margin: 0,
    display: "flex",
    alignItems: "center",
  },
  h2: {
    fontSize: "20px",
    fontWeight: "600",
    color: "#111827",
    margin: 0,
  },
  reportCard: {
    backgroundColor: "white",
    padding: "24px",
    borderRadius: "8px",
    border: "1px solid #E5E7EB",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
  },
  reportCardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: "1rem",
  },
  reportTitle: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#111827",
    margin: 0,
  },
  reportDesc: {
    fontSize: "14px",
    color: "#6B7280",
    margin: "4px 0 0 0",
  },
  monthlyBadge: {
    backgroundColor: "#EFF6FF",
    color: "#3B82F6",
    padding: "4px 12px",
    borderRadius: "9999px",
    fontSize: "12px",
    fontWeight: "500",
    height: "fit-content",
  },
  reportGenerated: {
    fontSize: "14px",
    color: "#6B7280",
    margin: "0 0 1.5rem 0",
  },
  reportCardFooter: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "1rem",
  },
  viewReportButton: {
    backgroundColor: "transparent",
    color: "#6B7280",
    border: "1px solid #D1D5DB",
    borderRadius: "6px",
    padding: "8px 16px",
    fontWeight: "500",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    fontSize: "14px",
  },
  downloadButton: {
    backgroundColor: "#2563EB",
    color: "white",
    border: "none",
    borderRadius: "6px",
    padding: "8px 16px",
    fontWeight: "500",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    fontSize: "14px",
  },
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    marginBottom: "1.5rem",
  },
  trendsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
  },
  trendItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "1rem",
    backgroundColor: "white",
    borderRadius: "8px",
    border: "1px solid #E5E7EB",
  },
  trendInfo: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  trendIcon: {
    backgroundColor: "#F3F4F6",
    padding: "8px",
    borderRadius: "6px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#3B82F6",
  },
  trendName: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#111827",
    margin: 0,
  },
  trendSubtitle: {
    fontSize: "12px",
    color: "#6B7280",
    margin: "2px 0 0 0",
  },
  trendChange: {
    fontSize: "16px",
    fontWeight: "bold",
    margin: 0,
  },
  regionsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
  },
  regionItem: {
    backgroundColor: "white",
    padding: "1rem",
    borderRadius: "8px",
    border: "1px solid #E5E7EB",
  },
  regionHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: "8px",
  },
  regionName: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#111827",
    margin: 0,
  },
  regionMembers: {
    fontSize: "12px",
    color: "#6B7280",
    margin: "2px 0 0 0",
  },
  performanceValue: {
    fontSize: "14px",
    fontWeight: "bold",
    color: "#3B82F6",
    margin: 0,
  },
  progressBarBg: {
    backgroundColor: "#F3F4F6",
    height: "8px",
    borderRadius: "9999px",
    overflow: "hidden",
  },
  progressBarFg: {
    height: "100%",
    borderRadius: "9999px",
    transition: "width 0.3s ease",
  },
  exportCard: {
    backgroundColor: "white",
    padding: "24px",
    borderRadius: "8px",
    border: "1px solid #E5E7EB",
    textAlign: "center",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
  },
  exportIcon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "12px",
  },
  exportTitle: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#111827",
    margin: "0 0 0.25rem 0",
  },
  exportDesc: {
    fontSize: "14px",
    color: "#6B7280",
    margin: 0,
  },
};

export default FullReportAccess;
